<template>
	<script type="text/x-template" id="template">
		<div class="scene"></div>
		<div class="thumbnail-info">
		    <div class="description">Scene $</div>
		</div>

		<div class="preview-opacity-container" style="display: none">
		    <span class="slider-name">Opacity</span>
		    <input type="range" min="0" max="100" value="100" step="0.001" class="range_slider thumbnail-slider">
		    <input type="text" class="range_value thumbnail_range" value="100" name="quantity" min="0" max="100" placeholder="0">
		</div>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
